export default "__VITE_ASSET__CNXPGvh3__";